import { useState, useEffect } from "react";
import * as Yup from "yup"; // ✅ Import Yup
import "../Stylesheets/Contact.css";

export default function Enquire() {
  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const [formData, setFormData] = useState({
    Name: "",
    course: "",
    email: "",
    phone: "",
    experience: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); // ✅ store errors here

  // ✅ Yup Validation Schema
  const validationSchema = Yup.object().shape({
    Name: Yup.string()
      .required("Name is required")
      .min(2, "Name must be at least 2 characters"),
    course: Yup.string().required("Course is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone must be a valid 10-digit number")
      .required("Phone is required"),
    experience: Yup.string().required("Skill level is required"),
    message: Yup.string()
      .required("Message is required")
      .min(10, "Message must be at least 10 characters long"),
  
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); // reset previous errors

    try {
      // ✅ validate formData with Yup
      await validationSchema.validate(formData, { abortEarly: false });

      setLoading(true);

      const payload = {
        ...formData,
        userName: formData.Name,
        userEmail: formData.email,
        userMobile: formData.phone,
        skillevel: formData.experience,
        course: formData.course,
        message: formData.message,
      };

      const response = await fetch(
        "https://node.vidhvaa.co.in/api/techbridge/common-enquire",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer cFRkdU1CYUhrRWZmUnZ5KmRDbGRoTFpVMklrNzVW6578a920b0ac2",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("API Success:", result);

      alert("Application Submitted Successfully!");
      setFormData({
        Name: "",
        email: "",
        phone: "",
        experience: "",
        message: "",
        course: "",
      });
    } catch (error) {
      if (error.name === "ValidationError") {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("API Error:", error);
        alert("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  const contactInfo = [
    {
      icon: "fas fa-envelope",
      title: "Email Us",
      content: "nb.techbridge@gmail.com",
    },
    { icon: "fas fa-phone", title: "Call Us", content: "+91 81488 80172" },
    { icon: "fas fa-phone", title: "Call Us", content: "+91 89259 59164" },
    { icon: "fas fa-phone", title: "Call Us", content: "+91 89259 59166" },
  ];

  return (
    <section id="contact" className="py-5 text-light form-bg">
      <h1
        className="fw-bold pb-3 text-center gradient-text"
        style={{ fontFamily: "'Merriweather', serif" }}
      >
        Your Career Journey Starts here
      </h1>

      <div className="container-fluid contact-form">
        {/* Title */}
        <div className="row mb-4">
          <div className="col-lg-8 mx-auto text-center">
            <p className="lead">
              Ready To Start Your Career? Enroll in Our Program And Take The
              First Step Towards Becoming a Expertised IT Professional.
            </p>
          </div>
        </div>

        {/* Form */}
        <div className="row d-flex justify-content-center">
          <div className="col-lg-8">
            <div className="contact shadow border-1 p-5 form-control-custom">
              <form onSubmit={handleSubmit}>
                <div className="row g-3 mt-2">
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      name="Name"
                      value={formData.Name}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter first name"
                    />
                    {errors.Name && (
                      <small className="text-danger">{errors.Name}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Course</label>
                    <select
                      className="form-select"
                      name="course"
                      onChange={handleInputChange}
                      value={formData.course}
                    >
                      <option value="">Select the Course</option>
                      <option value="react">React developer</option>
                      <option value="angular">Angular developer</option>
                      <option value="node">Python developer</option>
                      <option value="python">Node.js developer</option>
                      <option value="php">Php developer</option>
                      <option value="iOS">Ios developer</option>
                      <option value="Android">Android developer</option>
                      <option value="aws">AWS</option>
                      <option value="cloudengineer">Cloud Engineer</option>
                      <option value="devops">DevOps</option>
                    </select>
                    {errors.course && (
                      <small className="text-danger">{errors.course}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="your@email.com"
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter your mobile number"
                    />
                    {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                    )}
                  </div>

                  <div className="col-12">
                    <label className="form-label">Skill Level</label>
                    <select
                      name="experience"
                      value={formData.experience}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="">Select your Skill Level</option>
                      <option value="beginner">Beginner</option>
                      <option value="some">Some Knowledge</option>
                      <option value="intermediate">Intermediate</option>
                    </select>
                    {errors.experience && (
                      <small className="text-danger">{errors.experience}</small>
                    )}
                  </div>

                  <div className="col-12">
                    <label className="form-label">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows={4}
                      className="form-control"
                      placeholder="Tell us your queries..."
                    ></textarea>
                    {errors.message && (
                      <small className="text-danger">{errors.message}</small>
                    )}
                  </div>

                 

                  <div className="col-12 d-flex justify-content-center py-5">
                    <button
                      type="submit"
                      className="fs-5 gradient-bg btn border rounded-pill fw-bold w-50 text-light"
                      disabled={loading}
                    >
                      {loading ? (
                        "Submitting..."
                      ) : (
                        <>
                          <i className="fas fa-paper-plane me-2"></i> Submit
                          Application
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
